module.exports = __webpack_public_path__ + "a8b6449c615ef431d9ee6d592f94666f.png";